module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Acknowledgments#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a",
    attrs: {
      "id": "renergy"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Message#energy"
    }
  }, [_vm._v("A MESSAGE FROM THE RGS ENERGY CEO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a",
    attrs: {
      "id": "rforeword"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Foreword#foreword"
    }
  }, [_vm._v("FOREWORD: by Bill McKibben")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rintro"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Introduction#intro"
    }
  }, [_vm._v("INTRODUCTION: by John Schaeffer, Real Goods Founder")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter01#ch1"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter01#ch1"
    }
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1"
    }
  }, [_vm._v("RELOCALIZATION: "), _c('b', [_c('i', [_vm._v("A Strategic Response to Peak Oil and Climate Change")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec1"
    }
  }, [_vm._v("Ecological Economics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec2"
    }
  }, [_vm._v("Overshoot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec3"
    }
  }, [_vm._v("Peak Oil and Implications for a Transportation-Dependent Economy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec4"
    }
  }, [_vm._v("Climate Change and the Need to Eliminate Fossil Fuels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec5"
    }
  }, [_vm._v("Relocalization: A Strategic Response to Overshoot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec6"
    }
  }, [_vm._v("Approaching Social Change")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch1sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter01#ch1sec7"
    }
  }, [_vm._v("Pioneering Solar Down on the Farm")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "95",
      "src": "images/f0vii-01.jpg",
      "width": "98"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter02#ch2"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter02#ch2"
    }
  }, [_vm._v("2")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2"
    }
  }, [_vm._v("LAND AND SHELTER: "), _c('b', [_c('i', [_vm._v("Designing and Building Your Green Dream Home")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec1"
    }
  }, [_vm._v("The Impacts of Modern Building")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec2"
    }
  }, [_vm._v("Passive Survivability")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec3"
    }
  }, [_vm._v("Strategies for a Responsive Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec4"
    }
  }, [_vm._v("Renovations and Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec5"
    }
  }, [_vm._v("Building a New Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec6"
    }
  }, [_vm._v("Passive Solar Design: A Primer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec7"
    }
  }, [_vm._v("Building Technologies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec8"
    }
  }, [_vm._v("The Healthy Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec9"
    }
  }, [_vm._v("Your Home, Your Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2sec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec10"
    }
  }, [_vm._v("Words of Wisdom from Real Goods Staffers and Colleagues")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch2sec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2sec11"
    }
  }, [_vm._v("Spirit of the Sun")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "96",
      "src": "images/f0vii-02.jpg",
      "width": "100"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNSHINE TO ELECTRICITY: "), _c('b', [_c('i', [_vm._v("Creating Renewable Energy with Solar, Wind, and Hydroelectric Power")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Are Photovoltaic Cells?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixty Years of Photovoltaics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("System Examples")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PV Racking")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wind and Hydro Power Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydroelectricity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wind Energy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3sec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wind Energy and Wind Turbines — What You Need To Consider to Make a Decision")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch3sec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydrogen Fuel Cells")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "94",
      "src": "images/f0vii-03.jpg",
      "width": "97"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROM PANEL TO PLUG: "), _c('b', [_c('i', [_vm._v("How to Get Your Renewable Energy Source Powering Your Appliances")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Renewable Energy System Primer: Putting It All Together")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Off-grid and Battery Backup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("System Sizing Worksheets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grid-tied Systems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Converting Sunshine into Electricity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s the Payback?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety and Fusing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charge Controllers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monitors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Large Storage Batteries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real Goods’ Battery Troubleshooting Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Common Battery Questions and Answers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real Goods’ Battery Care Class")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rechargeable Batteries and Chargers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec15"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frequently Asked Questions About Rechargeable Batteries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inverters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec17"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potential Problems with Modified Sine Wave Inverter Use — and How to Correct Them")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec18"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potential Problems with ALL Inverters — and How to Correct Them")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec19"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inverter Conclusions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec20"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wire, Adapters, and Outlets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec21"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wire Sizing Chart/Formula")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4sec22"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RGS Energy Solar Project Case Study: Ironhouse Sanitary District")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch4sec23"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04a#ch4sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RGS Energy Solar Project Case Study: Little Quittacas Solar Farm")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "96",
      "src": "images/f0viii-01.jpg",
      "width": "99"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMERGENCY PREPAREDNESS AND SOLAR MOBILITY: "), _c('b', [_c('i', [_vm._v("Be Empowered When the Grid Goes Down")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch5sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter05#ch5sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Want Some Protection, or at Least a Little Backup? How About Total Freedom?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch5sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter05#ch5sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steps to a Practical Emergency Power System")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch5sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter05#ch5sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Do You Really Need in an Emergency?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch5sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter05#ch5sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "94",
      "src": "images/f0viii-02.jpg",
      "width": "99"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENERGY CONSERVATION: "), _c('b', [_c('i', [_vm._v("Superefficient Lighting, Heating, and Cooling Are the First Steps")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living Well but Inexpensively")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It All Starts with Good Design")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retrofitting: Making the Best of What You’ve Got")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conserving Electricity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House Heating and Cooling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Cooling Systems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Energy-efficient Appliances")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06a#ch6sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superefficient Lighting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6sec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06a#ch6sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lighting Characteristics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch6sec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06a#ch6sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light Technology")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "95",
      "src": "images/f0viii-03.jpg",
      "width": "99"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WATER DEVELOPMENT: "), _c('b', [_c('i', [_vm._v("Reckoning with Our Most Precious and Endangered Resource")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch7sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter07#ch7sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Components of Every Water System")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch7sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter07#ch7sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar-Powered Pumping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch7sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter07#ch7sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real Goods’ Homestead Plumbing Recommendations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch7sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter07#ch7sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friction Loss Charts for Water Pumping")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "95",
      "src": "images/f0ix-01.jpg",
      "width": "99"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WATER HEATING: "), _c('b', [_c('i', [_vm._v("The Most Cost-effective Solar Alternative")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch8sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter08#ch8sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Common Water Heater Types")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch8sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter08#ch8sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar Water Heaters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch8sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter08#ch8sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Solar Water Heating Systems: Operation and Installation")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "93",
      "src": "images/f0ix-02.jpg",
      "width": "98"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WATER AND AIR PURIFICATION: "), _c('b', [_c('i', [_vm._v("Clean Water and Air Are Human Rights!")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch9sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter09#ch9sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Need for Water Purification")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch9sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter09#ch9sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Methods of Water Filtration and Purification")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch9sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter09#ch9sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air Purification")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch9sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter09#ch9sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "93",
      "src": "images/f0ix-03.jpg",
      "width": "97"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMPOSTING TOILETS AND GREYWATER SYSTEMS: "), _c('b', [_c('i', [_vm._v("Novel, Safe, and Clean Solutions to an Age-old Human Issue")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch10sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter10#ch10sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reclaiming Valuable Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch10sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter10#ch10sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is a Composting Toilet?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch10sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter10#ch10sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greywater Systems")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "94",
      "src": "images/f0ix-04.jpg",
      "width": "100"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REGENERATIVE HOMESTEADING AND FARMING: "), _c('b', [_c('i', [_vm._v("Growing Your Own Organically Using the Permaculture Principles While Living the Good Life")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch11sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#ch11sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permaculture: A Holistic Design System for Your Site")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch11sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#ch11sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biodynamic"), _c('sup', [_vm._v("®")]), _vm._v(" Agriculture: Food and the Cosmos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch11sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#ch11sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biodynamic Preparations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch11sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#ch11sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "98",
      "src": "images/f0ix-05.jpg",
      "width": "101"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("URBAN HOMESTEADING: "), _c('b', [_c('i', [_vm._v("Heirloom Skills for Sustainable Living")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Urban Permaculture Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gardening in the Urban Habitat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animals on the Urban Homestead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remaking Our Relationship to Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heirloom Kitchen Skills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natural Building")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Powering Down")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greywater and Rainwater Use")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waste")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12sec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Ecology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch12sec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "97",
      "src": "images/f0ix-06.jpg",
      "width": "100"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUSTAINABLE TRANSPORTATION: "), _c('b', [_c('i', [_vm._v("Toward a Future of Carbon-free Mobility")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch13sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem with Fossil Fuels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch13sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem with Today’s Motor Vehicles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch13sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hybrids and Other Low-emission Vehicles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch13sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biodiesel, Ethanol, and Other Biofuels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch13sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Electric Vehicles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch13sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Futuristic Vehicles?")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "93",
      "src": "images/f00x-01.jpg",
      "width": "97"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NATURAL BURIAL: "), _c('b', [_c('i', [_vm._v("The Ultimate Back-to-the-land Movement")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dying to Do the Right Thing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When It’s Time, Will You “Leave No Trace”?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cemetery Stewardship’s Triple Bottom Line")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crafting the Fond Farewell: It Takes a Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What You Need for a Natural Burial")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Place to Go")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch14sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Acts That Make a Difference: How Your Support of Environmentally Friendly Products Can Turn an Industry Around")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "91",
      "src": "images/f00x-02.jpg",
      "width": "95"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', [_c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter")])]), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE REAL GOODS’ SUSTAINABLE LIVING LIBRARY: "), _c('b', [_c('i', [_vm._v("Reading for a Renewable Future")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15sec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garden, Farm, Food, and Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15sec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Land and Shelter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15sec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Renewable Energy in Theory and Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15sec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building Types and Materials")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15sec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peak Oil, Relocalization, and Politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15sec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch15sec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References and Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "96",
      "src": "images/f00x-03.jpg",
      "width": "97"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rapp"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I: Who We Are and How We Got Here")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Living the Dream: The Real Goods Solar Living Center")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Spreading the Word: The Solar Living Institute")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV: Getting Down to Business")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("System Sizing Worksheets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power Consumption Table")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar Insolation Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar Insolation by US City")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magnetic Declination Charts in the United States")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battery Wiring Diagrams")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wire Sizing Chart/Formula")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friction Loss Charts for Water Pumping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temperature Conversions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nominal Pipe Size Versus Actual Outside Diameter for Steel and Plastic Pipe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec15"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Real Goods’ Resource List")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rappsec16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Appendix#appsec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("State Energy Offices Access Information")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rglossary"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Glossary#glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rnotes"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Endnotes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0